import { useFormContext, type FieldValues } from "react-hook-form";
import { useLingui } from "@lingui/react/macro";
import Checkbox from "@/components/Checkbox/Checkbox";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import { weekdaySchema } from "@/api/Activities";
import { weekdayDictionary } from "./schedulingModels";
import {
  useFieldErrorWithPrefix,
  useFieldPathWithPrefix,
} from "@/forms/FormFieldPathPrefixContext";
import { useIsInFinalValidationPhase } from "@/forms/AddActivity/TemplateFieldValidationContext";
import type { TemplateWeekdaysPickerFields } from "@/forms/AddActivity/templateFormSchema";

export const TemplateWeekdaysPicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const fieldName =
    useFieldPathWithPrefix<TemplateWeekdaysPickerFields>("weekdays");
  const errorMessage = useFieldErrorWithPrefix<TemplateWeekdaysPickerFields>(
    errors,
    "weekdays",
  );
  const isInFinalValidationPhase = useIsInFinalValidationPhase();

  const weekdays = Object.values(weekdaySchema.enum);

  return (
    <Checkboxes
      errorMessage={errorMessage}
      orientation="horizontal"
      legend={t`Upprepa på`}
    >
      {weekdays.map((weekday) => (
        <Checkbox
          key={weekday}
          label={{ text: t(weekdayDictionary[weekday].short) }}
          {...register(fieldName, {
            required: isInFinalValidationPhase
              ? {
                  value: true,
                  message: t`Ange minst en veckodag`,
                }
              : undefined,
          })}
          value={weekday}
          visualStyle="framed"
        />
      ))}
    </Checkboxes>
  );
};
